import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import { APRCalculatorField, setHighestPriceChange, setLowestPriceChange, setUseCustomRange } from './actions'
import { StakingState } from './reducer'

// Select the entire staking state
function useStakingState(): StakingState {
  return useAppSelector((state) => state.staking)
}

// Hook for APR calculator state
export function useAPRCalculatorState(): {
  lowestPriceChange: number
  highestPriceChange: number
  useCustomRange: boolean
} {
  const state = useStakingState()

  return {
    lowestPriceChange: state[APRCalculatorField.LOWEST_PRICE_CHANGE],
    highestPriceChange: state[APRCalculatorField.HIGHEST_PRICE_CHANGE],
    useCustomRange: state.useCustomRange,
  }
}

// Hooks for APR calculator actions
export function useAPRCalculatorActions(): {
  onLowestPriceChangeInput: (value: number) => void
  onHighestPriceChangeInput: (value: number) => void
  onToggleCustomRange: (enabled: boolean) => void
} {
  const dispatch = useAppDispatch()

  const onLowestPriceChangeInput = useCallback(
    (value: number) => {
      dispatch(setLowestPriceChange({ value }))
    },
    [dispatch]
  )

  const onHighestPriceChangeInput = useCallback(
    (value: number) => {
      dispatch(setHighestPriceChange({ value }))
    },
    [dispatch]
  )

  const onToggleCustomRange = useCallback(
    (enabled: boolean) => {
      dispatch(setUseCustomRange({ enabled }))
    },
    [dispatch]
  )

  return {
    onLowestPriceChangeInput,
    onHighestPriceChangeInput,
    onToggleCustomRange,
  }
}
